import React from "react"
export function Download(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10.75 9.5v6.419L12.668 14l1.052 1.054-3.224 3.228a.743.743 0 01-.969.072l-.083-.072-3.224-3.228L7.272 14l1.978 1.981V9.5h1.5zm5.751-7.75a.75.75 0 01.743.648l.007.102v15a.75.75 0 01-.648.743l-.102.007h-2.164v-1.5h1.414V3.25h-11.5v13.5h1.412v1.5H3.501a.75.75 0 01-.743-.648l-.007-.102v-15a.75.75 0 01.649-.743L3.5 1.75h13z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__download"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
